<template>
    <div class="paginador">
        <a @click="prev" class="prev">Anterior</a>
        <a v-for="(e,key) in pages" :key="key" @click="set(e)" :active="selected == e">{{e}}</a>
        <a @click="next" class="next">Siguiente</a>
    </div>
</template>

<script>
    export default{
        name : 'paginador-el',
        props : ['perPage','max', 'current'],
        emits: ['update:modelValue'],
        data() {
            return {
                selected : this.current ?? 1,
            }
        },
        computed:{
            pages() {
                return Math.ceil((this.max / this.perPage));
            }
        },
        methods : {
            set(e){
                this.selected = e;
                this.$emit('update:modelValue',this.selected);
            },
            next(){
                if(this.selected < this.pages){
                    this.selected++;
                    this.$emit('update:modelValue',this.selected);
                }
            },
            prev(){
                if(this.selected > 1){
                    this.selected--;
                    this.$emit('update:modelValue',this.selected);
                }
            },
        }
    }
</script>